import * as WHITE_LABEL_THEME from 'white-label/themes/Car';

const whiteLabel = window.WHITE_LABEL_CONFIG;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const themes = require(`white-label/themes/${whiteLabel.theme}`);
const THEME = themes.THEME as typeof WHITE_LABEL_THEME.THEME;
const MAIN = THEME;

export type THEME_TYPE = typeof THEME;
export { THEME, MAIN };
